export default "__VITE_ASSET__8ae23394__"